Namespace 'Customer.Ticket'

class Customer.Ticket.NewTicketView extends Backbone.View
  template: JST['backbone/templates/customer/ticket/new_ticket']

  initialize: (@options = {}) ->
    @viewId = UniqueId.generate()
    @newCaseView = @options.newCaseView
    @signatures = @options.data.signatures
    @enabled_email_social_accounts = @options.data.enabledEmailSocialAccounts
    @default_email_subject_by_social_account_email = @options.data.default_email_subject_by_social_account_email

  render: ->
    @$el.html(@template())
    @_renderHeaderView()
    @_renderTextView()
    @_renderDetailBoxView()
    @

  _renderHeaderView: ->
    @headerView = new Customer.Ticket.TicketHeaderView
      model: null
      data: @options
    @$el.find('#new-ticket-header').html(@headerView.render().el)

  _renderTextView: ->
    @textView?.onDetach() if @textView
    @textView = new Customer.Dashboard.TicketNewEmailTextView
      enabledEmailSocialAccounts: @enabled_email_social_accounts
      defaultEmailSubjectBySocialAccountEmail: @default_email_subject_by_social_account_email
      ticketView: @
    @$('.form-container.response-form').html(@textView.render().el)
    @listenTo(@textView, 'press:cancel', => @trigger('press:cancel'))

  _renderDetailBoxView: ->
    @detailBox = new Customer.Dashboard.TicketEmptyDetailBox
    @$('.ticket-details-box').append(@detailBox.render().el)

  getSignatures: ->
    new Customer.SignaturesCollection(@signatures)

  onCancel: ->
    @trigger('close:tab')

  onDetach: ->
    @textView?.onDetach()

  onAttach: ->
    @textView?.onAttach()

  onSend:(parameters) ->
      $.ajax(
        type: 'POST',
        url: '/customer/dashboard/start_new',
        data: parameters,
        error: @_onSendError,
        success: (response) =>
          if response.success
            @_onTicketCreationSuccess(response.conversation)
          else
            @_onSendError()
      )

  _onSendError: =>
    swal({
      title: I18n.t('customer.dashboard.new_case.modal.error_title'),
      text: I18n.t('customer.dashboard.new_case.modal.error_description'),
      type: 'error',
      confirmButtonText: I18n.t('customer.dashboard.new_case.modal.error_confirm')
    })
    @textView.onSendError()

  _onTicketCreationSuccess: (conversation) =>
    swal({
      title: I18n.t('customer.dashboard.new_case.modal.success_title'),
      text: I18n.t('customer.dashboard.new_case.modal.success_description'),
      type: 'success',
      confirmButtonText: I18n.t('customer.dashboard.new_case.modal.success_confirm')
    })
    @model = new Customer.Ticket(JSON.parse(conversation), [])
    @model.fetch({
      silent: true
      global: false
      data: { page: 1 }
      success: (ticket) =>
        ticket.open()
        @trigger('close:tab')
      error: (model, response, options) =>
        if (response.status >= 500 )
          showError('An unexpected error has occurred. Please contact us if this error persists.')
          jsLogger.fatal("An error has occurred with the ticket with id: "+ model.id)
        else
          showError('You no longer have access to this ticket.')
    })


## Tab Interfaces

  onCloseTab: ->

  stopFetchingUpdates: ->

  startFetchingUpdates: ->

  onSelectTab: (dashboard) ->
    dashboard.showFilters(false)

  scrollTo: (position) ->
    @$el.find('#nano-detail').scrollTop(position)

  currentScrollPosition: () ->
    @$el.find('#nano-detail').scrollTop()

  tabName: ->
    'New Ticket'

  tabId: ->
    @viewId

  uniqueId: ->
    @viewId

  iconSelector: ->
    'email'
